import MenusModule from './menus.module'

export default MenusModule
